import React from "react";
import { Link } from "react-router-dom";

const ServiceTerms = () => {
  const content = `서비스 이용약관


제 1 조 【목 적】
본 약관은 주식회사 마이즈(이하 ’회사’ 또는 ‘마이즈’)가 운영하는 건설현장 스마트 통합관리 시스템인 MIZE Smart Safety에서 제공하는 서비스(이하 ‘서비스’)를 이용함에 있어 회사와 회원의 권리, 의무 및 책임사항, 기타 필요한 사항을 명확하게 규정함을 목적으로 합니다.

제 2 조 【정 의】
본 약관에서 사용하는 용어의 정의는 다음과 같습니다. 
①  “서비스”란 회사가 제공하는 건설현장 안전관리, 출입통제, 위치관제, 작업관리, 위험알림 등의 기능을 포함한 플랫폼을 의미합니다.
② “이용자”란 본 약관에 따라 회사와 이용계약을 체결하고 서비스를 이용하는 법인 또는 개인을 의미합니다.
③ “관리자”란 이용자의 소속 직원으로서 서비스의 운영 및 관리 권한을 부여받은 자를 의미합니다.는 서비스를 이용해 상품에 관한 정보를 게재하고, 상품을 제공하는 판매자를 말합니다.
④ “현장 사용자”란 건설현장에서 서비스를 이용하는 근로자 및 관계자를 의미합니다.
⑤ “단말”이란 서비스 이용을 위해 사용되는 모바일 기기, 태블릿, 키오스크, 센서 및 기타 장비를 의미합니다.

제 3 조 【약관의 게시와 개정】
① 회사는 본 약관의 내용을 사용자가 쉽게 알 수 있도록 홈페이지 초기화면(모바일 웹, 앱 등)에 게시합니다. 다만, 약관의 내용은 사용자가 연결화면을 통하여 보도록 할 수 있습니다.
② 회사는 전자상거래 등 에서의 소비자 보호에 관한 법률, 약관의 규제에 관한 법률, 전자문서 및 전자거래기본법, 전자서명법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 소비자기본법 등 관련법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 본 제1항의 방식에 따라 그 재정약관의 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자의 권리 또는 의무에 관한 중요한 사항의 변경 또는 사용자에게 불리한 약관의 변경은 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 회사는 개정 전과 개정 후 내용을 사용자가 알기 쉽도록 표시합니다.
④ 이용자는 변경된 약관에 동의하지 않을 권리가 있으며, 변경된 약관에 동의하지 않을 경우에는 서비스 이용을 중단하고 탈퇴할 수 있습니다. 다만, 회원이 제3항의 방법 등으로 회사가 별도 고지한 약관 개정 공지 기간 내에 회사에 개정 약관에 동의하지 않는다는 명시적인 의사표시를 하지 않는 경우 변경된 약관에 동의한 것으로 간주합니다.

제 4 조 【약관의 해석】
①  본 약관에서 정하지 아니한 사항에 대해서는 관련 법령 및 상관례에 따릅니다.
② 회사는 서비스 운영을 위하여 별도의 운영정책을 둘 수 있으며, 해당 내용은 본 약관의 일부로 간주됩니다.
③ 본 약관과 개별 계약 또는 별도 약정 간 내용이 상충하는 경우에는 개별 계약 또는 별도 약정이 우선 적용됩니다.

제 5 조 【이용계약의 체결】
①  이용계약은 서비스를 이용하고자 하는 자가 회사가 정한 절차에 따라 이용신청을 하고, 회사가 이를 승인함으로써 체결됩니다.
② 이용자는 신청 시 사실과 다른 정보를 제공하여서는 아니 되며, 회사는 허위 정보가 확인될 경우 승인을 거부하거나 이용계약을 해지할 수 있습니다.
③ 회사는 다음 각 호에 해당하는 경우 이용신청을 승낙하지 않거나 사후에 이용계약을 해지할 수 있습니다.
 (1) 기술적 또는 운영상 서비스 제공이 어려운 경우
 (2) 이용자가 본 약관을 위반하여 이용계약이 해지된 이력이 있는 경우
 (3) 기타 회사가 서비스 제공이 부적절하다고 판단하는 경우
④ 이용계약의 성립 시기는 회사의 승낙이 이용자에게 도달한 시점으로 합니다.
⑤ 서비스 이용에 관한 세부 사항은 별도로 체결하는 계약서 또는 서비스 신청서에 따를 수 있습니다.

제 6 조 【개인정보보호 의무】
①  회사는 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다.
② 개인정보의 보호 및 이용에 대해서는 관련법 및 회사의 개인정보 처리방침이 적용됩니다. 다만, 회사의 공식사이트 이외의 링크된 사이트에서는 회사의 개인정보 처리방침이 적용되지 않습니다.
③ 회사가 개인정보의 보호를 위하여 상당한 주의를 기울였음에도 불구하고, 호스트가 관련 법령 및 본 이용약관을 위반하여 회원의 개인정보를 유출 또는 유용한 경우 회사는 그에 대하여 아무런 책임을 부담하지 않습니다.

제 7 조 【이용자의 의무】
①  이용자는 관련 법령, 본 약관 및 회사가 공지하는 사항을 준수하여야 합니다.
② 이용자는 다음의 행위를 하여서는 안 됩니다.
 (1) 서비스 신청 또는 이용 과정에서 허위 정보의 제공
 (2) 타인의 계정 도용 또는 부정 사용
 (3) 제3자가 계정을 사용하도록 하는 행위
 (4) 서비스의 정상적인 운영을 방해하는 행위
 (5) 서비스 내 정보 또는 데이터를 무단으로 복제, 유통, 상업적으로 이용하는 행위
 (6) 회사 또는 제3자의 권리를 침해하는 행위
 (8) 회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위 
 (9) 기타 불법적이거나 부당한 행위
③ 이용자는 관련 법령, 본 약관의 규정, 이용정책 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.

제 8 조 【탈퇴 및 자격 상실 등】
①  이용자는 언제든지 회사에 이용계약 해지를 요청할 수 있으며, 회사는 관련 법령 및 계약 조건에 따라 이를 처리합니다.
② 회사는 이용자가 다음 각 호의 사유에 해당하는 경우 사전 통지 후 이용계약을 해지하거나 서비스 이용을 제한할 수 있습니다. 다만, 긴급한 경우 사후 통지할 수 있습니다.
 (1) 본 약관을 위반한 경우
 (2) 서비스 이용요금을 정당한 사유 없이 지급하지 아니한 경우
 (3) 서비스의 정상적인 운영을 방해한 경우
③ 이용계약이 해지되는 경우, 관련 법령 및 회사의 정책에 따라 이용자의 데이터는 일정 기간 보관 후 삭제될 수 있습니다.

제 9 조 【서비스의 제공 등】
①  회사는 다음 각 호의 서비스를 제공합니다.
 (1) 건설현장 출입 및 출역관리 서비스
 (2) 근로자 작업관리 및 안전관리 서비스
 (3) 현장 관제 및 모니터링 서비스
 (4) 통계 및 보고서 제공 서비스
② 회사는 서비스의 일부 또는 전부를 운영상 또는 기술상의 필요에 따라 변경, 추가 또는 중단할 수 있습니다.
③ 서비스는 네트워크 환경, 단말 성능, 현장 여건 등에 따라 일부 기능이 제한될 수 있습니다.
④ 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 회원에게 전자우편주소로 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
⑤ 회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있습니다.

제 10 조 【회사의 의무】
① 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적인 시스템의 제공을 위하여 최선을 다하여 노력합니다.
② 회사는 이용자가 안전하게 시스템을 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보 처리방침을 공시하고 준수합니다.
③ 회사는 시스템 제공과 관련하여 알고 있는 이용자의 개인정보를 사용자의 승낙없이 제3자에게 누설, 배포하지 않습니다. 다만, 관계법령에 의한 관계기관으로부터의 요청 등 법률의 규정에 따른 적법한 절차에 의한 경우에는 그러하지 않습니다.
④ 회사는 이용자에게 제공되는 시스템을 연중 1일 24시간 계속적이고 안정적으로 제공하며, 설비장애가 생기거나 멸실되었을 때 지체없이 이를 수리 또는 복구합니다. 다만, 회사의 업무상.기술상의 사유 또는 천재지변이나 비상사태 등 부득이한 경우에는 시스템을 일시 중단하거나 영구 중지할 수 있으며, 이러한 경우, 회사는 홈페이지 게시, 이동전화 단문메시지서비스(SMS), 이메일 등을 통해 사전 또는 사후적으로 이를 고지합니다.
⑤ 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 합리적인 기간 내에 신속하게 처리하여야 합니다. 다만, 처리에 장기간이 소요되는 경우는 회원에게 게시판 또는 이메일 등을 통하여 지체 사유를 안내하고 처리과정 및 처리결과를 전달합니다.

제 11 조 【책임제한】
① 회사는 천재지변, 불가항력, 서비스용 설비의 보수,교체,점검,공사 등 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
② 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
③ 회사는 이용자가 서비스를 이용하여 기대하는 효과를 얻지 못하거나, 서비스 자료에 대한 선택 또는 이용으로 발생한 결과에 대하여 책임을 지지 않습니다.
④ 회사는 이용자의 단말 환경, 네트워크 상태 또는 현장 여건 등 외부 요인으로 인한 서비스 이용 제한에 대하여 책임을 지지 않습니다.
⑤ 본 서비스는 건설현장 안전관리를 지원하기 위한 보조 수단으로 제공되며, 안전사고 예방 및 관리에 대한 최종 책임은 이용자에게 있습니다.

제 12 조 【준거법 및 재판관할】
① 회사와 이제기된 소송은 대한민국법을 준거법으로 합니다.
② 회사와 이용자간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다. 

제 13 조 【이용약관 변경 및 고지의무】
① 서비스 이용약관은 법령 또는 회사의 정책에 따라 그 내용이 변경될 수 있으며, 내용의 추가 및 삭제, 수정이 있을 시에는 홈페이지를 통해 변경내용 및 사유를 공지하도록 하겠습니다.
② 본 서비스 이용약관은 2025년 08월 01일 부터 시행되며, 종전의 서비스 이용약관은 본 서비스 이용약관으로 대체됩니다.

`;

  return (
    <div className="terms_page">
      <div className="terms_box">
        <h1 className="terms_title">서비스 이용약관</h1>

        <div className="terms_content">{content}</div>
      </div>
    </div>
  );
};

export default ServiceTerms;
